import React from "react";
//#region types
import { ConnectInvoiceItemProps } from "models/propTypes/timeReportingProjectPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ConnectInvoiceItem: React.FC<ConnectInvoiceItemProps> = (props) => {
  const { invoiceInfo } = props;

  const invoiceAmount = invoiceInfo.totalAmount;

  return invoiceInfo ? (
    <Grid item xs container className={cssExports.searchResultTextContainer}>
      <Grid item xs={8} container direction={"column"}>
        <Grid item className={cssExports.invoicePickerItemText}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.InvoiceWithSerialNumber, "", {
            serialNumber: (invoiceInfo.serialNumber ?? "").toString(),
          })}
        </Grid>
        <Grid item className={cssExports.invoicePickerItemDescription}>
          {LocalizationHelperInstance.getFormattedDate(invoiceInfo.postingDate)}, {invoiceInfo.customerName}
        </Grid>
      </Grid>
      <Grid item xs={4} container direction={"column"} className={cssExports.invoicePickerAmountContainer}>
        <Grid item className={cssExports.invoicePickerItemDescription}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Amount)}
        </Grid>
        <Grid item className={cssExports.invoicePickerAmountText}>
          {LocalizationHelperInstance.getFormattedCurrency(invoiceAmount, invoiceInfo.currency, 2)}
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default ConnectInvoiceItem;
